import { useTranslation } from '@/i18n/client';
import { observer } from 'mobx-react';
import styles from './index.module.scss';
// 组件
import UKDialog from '@/components/UKDialog';
import CDNImage from '@/components/cdnImage/cdnImage';
import { DialogActions, DialogTitle } from '@mui/material';
import CommonButton from '../commonButton';
// 接口
import { DeliveryinfoVo, LogisticsInfoVo } from '@/apis/order/order.interface';

interface pickUpCodeModalProps {
  isOpen: boolean;
  closeHandler: () => void;
  modalInfo: LogisticsInfoVo | DeliveryinfoVo | undefined;
}

const pickUpCodeModal: React.FC<pickUpCodeModalProps> = observer(
  ({ isOpen, closeHandler, modalInfo }) => {
    const { t } = useTranslation();
    const { pickCodePicUrl, pickupCode } = modalInfo || {};

    return (
      <UKDialog
        open={isOpen}
        onClose={closeHandler} // 关闭弹窗
        sx={{
          '& .MuiDialog-paper': {
            width: '380px', // 设置自定义宽度
            minWidth: '380px',
          },
        }}
      >
        <div>
          <DialogTitle
            sx={{
              paddingTop: '20px',
              paddingBottom: '0',
            }}
          >
            {t('order.orderDetail.orderDetailStatus.pickUpCode')}
          </DialogTitle>
          <div className={styles.pickUpCodeModalContent}>
            <CDNImage
              src={pickCodePicUrl || ''}
              width={300}
              height={76}
              alt='barcode'
              style={{ objectFit: 'contain', height: '76px', marginTop: '16px' }}
            />
            <div className={styles.pickCodeStyle}>{pickupCode}</div>
          </div>
          <DialogActions
            sx={{
              paddingTop: '0',
            }}
          >
            <CommonButton variant='contained' onClick={closeHandler} sx={{ boxShadow: 'none' }}>
              {t('common.btnText.ok')}
            </CommonButton>
          </DialogActions>
        </div>
      </UKDialog>
    );
  },
);

export default pickUpCodeModal;
